import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const BookOutline = createIcon({
  displayName: 'BookOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M4,19V5A2,2,0,0,1,6,3H18a2,2,0,0,1,2,2V16a1,1,0,0,1-1,1H6a2,2,0,0,0-2,2H4a2,2,0,0,0,2,2H20"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8"
        y1="17"
        x2="8"
        y2="3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="19"
        y1="21"
        x2="19"
        y2="17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const BookTwoTone = createIcon({
  displayName: 'BookTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <Box
          as="path"
          d="M4,19V5A2,2,0,0,1,6,3H18a2,2,0,0,1,2,2V16a1,1,0,0,1-1,1H6a2,2,0,0,0-2,2H4a2,2,0,0,0,2,2H20"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="8"
          y1="17"
          x2="8"
          y2="3"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="19"
          y1="21"
          x2="19"
          y2="17"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </Box>
    </>
  ),
})

const Book: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={BookTwoTone} {...props} />
  default:
    return <CustomIcon as={BookOutline} {...props} />
  }
}

export default memo(Book)
